<div class="password-hints">
  <!-- Strength bar (only shown when user has started typing) -->
  @if (password) {
    <div class="strength-bar-wrapper">
      <div class="strength-bar">
        <div class="strength-fill" [ngClass]="strengthClass" [style.width.%]="(strengthScore + 1) * 20"></div>
      </div>
      <span class="strength-label" [ngClass]="strengthClass">{{ strengthLabelKey | translate }}</span>
    </div>
  }

  <!-- Required rules -->
  <div class="hint-item" [class.hint-met]="hasMinLength">
    <lucide-icon class="hint-icon" [name]="hasMinLength ? 'circle-check' : 'circle'"></lucide-icon>
    <span>{{ 'password_hints.min_length' | translate: { length: minLength } }}</span>
  </div>

  <div class="hint-item" [class.hint-met]="hasLetter">
    <lucide-icon class="hint-icon" [name]="hasLetter ? 'circle-check' : 'circle'"></lucide-icon>
    <span>{{ 'password_hints.has_letter' | translate }}</span>
  </div>

  <div class="hint-item" [class.hint-met]="hasNumber">
    <lucide-icon class="hint-icon" [name]="hasNumber ? 'circle-check' : 'circle'"></lucide-icon>
    <span>{{ 'password_hints.has_number' | translate }}</span>
  </div>

  <!-- Recommended rules — not blocking, shown with a lightbulb icon when unmet -->
  <div class="hint-item hint-recommended" [class.hint-met]="hasUpperAndLower">
    <lucide-icon class="hint-icon" [name]="hasUpperAndLower ? 'circle-check' : 'lightbulb'"></lucide-icon>
    <span>{{ 'password_hints.has_upper_lower' | translate }}</span>
  </div>

  <div class="hint-item hint-recommended" [class.hint-met]="hasSpecialChar">
    <lucide-icon class="hint-icon" [name]="hasSpecialChar ? 'circle-check' : 'lightbulb'"></lucide-icon>
    <span>{{ 'password_hints.has_special' | translate }}</span>
  </div>
</div>
